'use client';

import { useFeatureValue } from '@/feature-flags/hooks/use-feature-value.hook';

export interface UseNewScheduleResult {
  enabled: boolean;
  loading: boolean;
}

export function useNewSchedule(): UseNewScheduleResult {
  const { value, loading } = useFeatureValue('newSchedule');

  return { enabled: value, loading };
}
